import React from 'react';
import _ from 'lodash';
import Tippy from '../ReactTippy';
import { CCUS_PAGE } from '../../pages/PrimeCcusPreview';

export const CcusTable = ({
  data,
  columns,
  tableType,
  editAdmin,
  editUser,
  isRolePartner,
}) => {
  const renderTooltipContent = data => {
    return <div className='ccus-tooltip'>{data}</div>;
  };

  return (
    <table className='table CcusTable'>
      <thead className='table__header'>
        <tr className='table__label'>
          {_.map(columns, (item, index) => {
            const { name, classname } = item;
            return (
              <td key={index} className={classname}>
                {name}
              </td>
            );
          })}
        </tr>
      </thead>
      <tbody className='table__body'>
        {_.map(data, (item, index) => {
          if (tableType === 'admin') {
            const {
              ccus_company_admin_id,
              ccus_company_admin_name,
              user_count,
            } = item;
            return (
              <tr key={index}>
                <td className='value-table col-20'>{ccus_company_admin_id}</td>
                <td className='value-table col-20'>
                  <Tippy
                    duration={10}
                    distance={24}
                    arrowType='sharp'
                    delay={[500, 0]}
                    placement='bottom'
                    followCursor={true}
                    role={`tippy_target_${ccus_company_admin_name}`}
                    html={renderTooltipContent(
                      _.defaultTo(ccus_company_admin_name, '')
                    )}
                  >
                    <div className='value-table-name'>
                      {ccus_company_admin_name}
                    </div>
                  </Tippy>
                </td>
                <td className='value-table col-20'>
                  {user_count ? `${user_count}人` : '未登録'}
                </td>
                <td className='value-table value-btn col-20'>
                  <div className='btn-wrapper'>
                    <button
                      onClick={() => editAdmin(CCUS_PAGE.CcusAdminEdit, item)}
                      className='btn'
                    >
                      管理者情報を編集
                    </button>
                    <button
                      onClick={() =>
                        editUser(CCUS_PAGE.CcusAdminUserEdit, item)
                      }
                      className='btn'
                    >
                      {user_count ? '連携ユーザーを編集' : '連携ユーザーを登録'}
                    </button>
                  </div>
                </td>
              </tr>
            );
          } else {
            const {
              login_id,
              user_name,
              company_branch_name,
              partner_company_branch_name,
              company_name,
              agency_company_id,
              agency_company_name,
            } = item;
            return (
              <tr key={index}>
                {!_.isNull(agency_company_id) ? (
                  <td className='col-25 value-table'>
                    <Tippy
                      duration={10}
                      distance={24}
                      arrowType='sharp'
                      delay={[500, 0]}
                      placement='bottom'
                      followCursor={true}
                      role={`tippy_target_${agency_company_name}`}
                      html={renderTooltipContent(
                        _.defaultTo(agency_company_name, '本社')
                      )}
                    >
                      <div className='value-table-name'>
                        <span className='CcusUserEdit__agency-label' />
                        {agency_company_name}
                      </div>
                    </Tippy>
                  </td>
                ) : (
                  <td className='col-25 value-table'>
                    <Tippy
                      duration={10}
                      distance={24}
                      arrowType='sharp'
                      delay={[500, 0]}
                      placement='bottom'
                      followCursor={true}
                      role={`tippy_target_${company_name}`}
                      html={renderTooltipContent(
                        _.defaultTo(company_name, '本社')
                      )}
                    >
                      <div className='value-table-name'>
                        {_.isNull(company_name) ? '本社' : company_name}
                      </div>
                    </Tippy>
                  </td>
                )}
                {isRolePartner ? (
                  <td className='value-table'>
                    <Tippy
                      duration={10}
                      distance={24}
                      arrowType='sharp'
                      delay={[500, 0]}
                      placement='bottom'
                      followCursor={true}
                      role={`tippy_target_${partner_company_branch_name}`}
                      html={renderTooltipContent(
                        _.defaultTo(partner_company_branch_name, '本社')
                      )}
                    >
                      <div className='value-table-name'>
                        {_.isNull(partner_company_branch_name)
                          ? '本社'
                          : partner_company_branch_name}
                      </div>
                    </Tippy>
                  </td>
                ) : (
                  <td className='value-table'>
                    <Tippy
                      duration={10}
                      distance={24}
                      arrowType='sharp'
                      delay={[500, 0]}
                      placement='bottom'
                      followCursor={true}
                      role={`tippy_target_${company_branch_name}`}
                      html={renderTooltipContent(
                        _.defaultTo(company_branch_name, '本社')
                      )}
                    >
                      <div className='value-table-name'>
                        {_.isNull(company_branch_name)
                          ? '本社'
                          : company_branch_name}
                      </div>
                    </Tippy>
                  </td>
                )}
                <td className='value-table'>
                  <Tippy
                    duration={10}
                    distance={24}
                    arrowType='sharp'
                    delay={[500, 0]}
                    placement='bottom'
                    followCursor={true}
                    role={`tippy_target_${user_name}`}
                    html={renderTooltipContent(_.defaultTo(user_name, ''))}
                  >
                    <div className='value-table-name'>
                      {_.isNull(user_name) ? '**********' : user_name}
                    </div>
                  </Tippy>
                </td>
                <td className='col-30 value-table'>
                  <Tippy
                    duration={10}
                    distance={24}
                    arrowType='sharp'
                    delay={[500, 0]}
                    placement='bottom'
                    followCursor={true}
                    role={`tippy_target_${login_id}`}
                    html={renderTooltipContent(_.defaultTo(login_id, ''))}
                  >
                    <div className='value-table-name'>
                      {_.isNull(login_id) ? '**********' : login_id}
                    </div>
                  </Tippy>
                </td>
              </tr>
            );
          }
        })}
      </tbody>
    </table>
  );
};



// WEBPACK FOOTER //
// ./src/components/tables/CcusTable.jsx